import {
  BlockType,
  ColorSchemeSchema,
  FieldGroupSchema,
  FieldRole,
  ImageFieldSchema,
  RichTextFieldSchema,
} from './Types';
import { z } from 'zod';

export enum CardIconMode {
  Icon = 'icon',
  Index = 'index',
  None = 'none',
}

const CardIconModeSchema = z.nativeEnum(CardIconMode);

const CardStyleSchema = z.object({
  backgroundColor: z.string(),
});

enum ValuePropLayout {
  ThreeColumn = 'ThreeColumn',
}

const ValuePropLayoutSchema = z.nativeEnum(ValuePropLayout);

const ValuePropHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('header'),
  role: z.literal(FieldRole.Header),
});

const ValuePropSubheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('subheader'),
  role: z.literal(FieldRole.Subheader),
});

const ValuePropPreheaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('preheader'),
  role: z.literal(FieldRole.Preheader),
});

const ValuePropSolutionDescriptionFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('solutionDescription'),
  role: z.literal(FieldRole.Description),
});

const ValuePropSolutionHeaderFieldSchema = RichTextFieldSchema.extend({
  name: z.literal('solutionHeader'),
  role: z.literal(FieldRole.Header),
});

const ValuePropSolutionIconFieldSchema = ImageFieldSchema.extend({
  name: z.literal('solutionIcon'),
  role: z.literal(FieldRole.Image),
});

const ValuePropBlockFieldSchema = z.discriminatedUnion('name', [
  ValuePropHeaderFieldSchema,
  ValuePropSubheaderFieldSchema,
  ValuePropPreheaderFieldSchema,
]);

const ValuePropCardFieldSchema = z.discriminatedUnion('name', [
  ValuePropSolutionDescriptionFieldSchema,
  ValuePropSolutionHeaderFieldSchema,
  ValuePropSolutionIconFieldSchema,
]);

const ValuePropBlockFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(ValuePropBlockFieldSchema),
});

const ValuePropCardFieldGroupSchema = FieldGroupSchema.extend({
  fields: z.array(ValuePropCardFieldSchema),
});

const ValuePropStyleSchema = z.object({
  backgroundColor: z.string(),
});

const ValuePropOptionsSchema = z.object({
  cardIconMode: CardIconModeSchema.or(z.literal('')).optional(),
  cardStyle: CardStyleSchema.optional(),
  style: ValuePropStyleSchema.optional(),
  cardStyleEnabled: z.boolean().optional(),
  cardHeaderEnabled: z.boolean().optional(),
  preheaderEnabled: z.boolean().optional(),
  subheaderEnabled: z.boolean().optional(),
  entryCount: z.number().optional(),
  colorScheme: ColorSchemeSchema.optional(),
  layout: ValuePropLayoutSchema.optional(),
});

export const ValuePropBlockConfigSchema = z.object({
  options: ValuePropOptionsSchema,
  type: z.literal(BlockType.ValueProp),
  fieldGroups: z.tuple([ValuePropBlockFieldGroupSchema]).rest(ValuePropCardFieldGroupSchema),
  version: z.literal(1),
});
